export default __webpack_public_path__ + "static/media/under_process.beb8e95f.svg";